import axios from 'axios';
import { photos_url, directory } from '../config';

export const GET_IMAGES = 'GET_IMAGES';
export const POST_CART = 'POST_CART';

export function getImages(page) {
	const request = axios.get(`${photos_url}/${directory}/photos.php?page=${page}`);
	return {
		type: GET_IMAGES,
		payload: request
	};
}

export function postCart(cart) {
	const request = axios.post(`${window.location.origin}/${directory}contact.php`, cart);
	return {
		type: POST_CART,
		payload: request
	};
}

export function postCartAdmin(cart) {
	const request = axios.post(`${window.location.origin}/admin/api/collections/save/cunha?token=account-9ee3141c771d554d6baa91aea8cd68`, cart);
	return {
		type: POST_CART,
		payload: request
	};
}



// WEBPACK FOOTER //
// ./src/actions/index.js